import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

class MovimentacaoFiltro extends Component {
  static propTypes = {
    movimentacoes: PropTypes.object.isRequired
  };

  render() {
    const { movimentacoes } = this.props;

    if (movimentacoes.isEmpty()) {
      return null;
    }

    return (
      <section>
        <Panel title="Informações">
          <DisplayData border>
            <DisplayDataRow>
              <DisplayDataItem
                sm={6}
                title="Centro de Custo"
                value={movimentacoes.first().get('centroCustoDescricao')}
              />
              <DisplayDataItem
                sm={6}
                title="Item"
                value={movimentacoes.first().get('itemDescricao')}
              />
            </DisplayDataRow>
          </DisplayData>
        </Panel>

        <BotaoImprimir />
      </section>
    );
  }
}

export default MovimentacaoFiltro;
